// Libraries
import { Stack } from "@mui/material";

// Types
import { IKmsStore } from "@/Settings/types/administrationTools/model";
import { TSelectedKiosk } from "@/Settings/types/administrationTools/utils";
import { TSelectValue } from "@/Layouts/components/InputComponents/SmartSelector/interfaces";

// Components
import InfoSubTitle from "@/Settings/components/SystemSettings/common/InfoSubTitle";
import SmartSelector from "@/Layouts/components/InputComponents/SmartSelector";

// Utils
import {
	getKioskOptions,
	isThereAnyNewChangeInKioskDropdown,
} from "@/Settings/helpers/AdministrationTools/DealerAdministrationTools/KeyManagementSystem";

type TKioskSelectorProps = {
	isLoading: boolean;
	stores: IKmsStore[];
	onChange: (values: TSelectedKiosk[]) => void;
};

export default function KioskSelector(props: Readonly<TKioskSelectorProps>) {
	const { isLoading, stores, onChange } = props;

	const kioskOptions = getKioskOptions(stores);
	const selectedKiosks = kioskOptions.filter(({ selected }) => selected);

	function handleOnChangeAction(values: TSelectValue) {
		const updateSelectedKioskIds = (values as { id: number; storeId: number }[]).map(({ id: kioskId, storeId }) => ({
			storeId,
			kioskId,
		}));

		const currentSelectedKiosks = selectedKiosks.map(({ id, storeId }) => ({ storeId, kioskId: id }));
		isThereAnyNewChangeInKioskDropdown(currentSelectedKiosks, updateSelectedKioskIds) && onChange(updateSelectedKioskIds);
	}

	return (
		<Stack>
			<InfoSubTitle title={"Kiosks"} className={"!mb-[12px]"} />
			<SmartSelector
				selectBy="id"
				sortBy="storeName"
				showBy="label"
				orderBy="storeName"
				selected={selectedKiosks}
				options={kioskOptions}
				loading={isLoading}
				onChangeAction={handleOnChangeAction}
				multiple
				popperProps={{ className: "!z-[1350]" } as object}
				inputProps={{
					placeholder: "Kiosk(s)",
					classes: "!w-[280px] [&_.MuiInputBase-root>.MuiButtonBase-root>span.MuiChip-label]:!font-sans",
				}}
				listBoxProps={{
					sx: { maxHeight: "220px" },
				}}
				groupingProps={{
					groupBy: "storeName",
					specificProperties: {
						"*": {
							sx: { fontVariant: "!normal-case" },
						},
					},
					classes: "!text-primary !text-[14px]",
				}}
				renderTagsCustomProps={{
					showTagBy: "id",
				}}
			/>
		</Stack>
	);
}
